module.exports = __webpack_public_path__ + "static/media/HPCMP_Red&Black.cdb4693a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/HPCMP_Red&Black.png
// module id = 63
// module chunks = 0